import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import ReactTooltip from 'react-tooltip';
import skillsData from '../../data/skills.json';
import expData from '../../data/edu.json';
import { AppWrap, MotionWrap } from '../../wrapper';
import './Skills.scss';

const Skills = () => {
  const [education, setEducation] = useState([]);
  const [skills, setSkills] = useState([]);
  const [displayedSkillsCount, setDisplayedSkillsCount] = useState(12);
  useEffect(() => {
      setEducation(expData);
      setSkills(skillsData);
  }, []);
  const loadMoreSkills = () => {
    setDisplayedSkillsCount((prevCount) => prevCount + 12);
  };
  return (
    <>
      <h2 style={{color:"var(--primary-color)"}}>Top Skills and Education</h2>

      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.slice(0, displayedSkillsCount).map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill.name}
            >
              <div
                className="app__flex"
                style={{ backgroundColor: "var(--card-color)" }}
              >
                <img loading="lazy" className='tech-icon' src={skill.icon} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
          {/* show more skills */}
          {displayedSkillsCount < skills.length && (
            <motion.div
            whileInView={{ opacity: [0, 1] }}
            transition={{ duration: 0.5 }}
            className="app__skills-item app__flex"
            key="More"
          >
            <div
                className="app__flex"
                style={{ backgroundColor: "var(--card-color)" }}
              >
                <img loading="lazy" className='tech-icon' src="/icons/menu.png" alt="load-more-icon" onClick={loadMoreSkills} style={{ cursor: 'pointer'}} />
            </div>
            <p className="p-text">Load More Skills</p>
          </motion.div>
        )}
        {/* show less skills */}
        {displayedSkillsCount >= skills.length && (
            <motion.div
            whileInView={{ opacity: [0, 1] }}
            transition={{ duration: 0.5 }}
            className="app__skills-item app__flex"
            key="More"
          >
            <div
                className="app__flex"
                style={{ backgroundColor: "var(--card-color)" }}
              >
                <img loading="lazy" className='tech-icon' src="/icons/chevron.png" alt="show-less-icon" onClick={() => setDisplayedSkillsCount(12)} style={{ cursor: 'pointer'}} />
            </div>
            <p className="p-text">Show Less Skills</p>
          </motion.div>
        )}
        </motion.div>

        

        <div className="app__skills-exp">
          {education.map((edu) => (
            <motion.div
              className="app__skills-exp-item"
              key={edu.start}
            >
              <div className="app__skills-exp-year">
                <p className="bold-text">{edu.start}</p>
                <p className="bold-text">{edu.end}</p>
              </div>
              <motion.div className="app__skills-exp-works">
                
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className="app__skills-exp-work"
                      data-tip
                      data-for={edu.name}
                      key={edu.name}
                    >
                      <h4 className="bold-text">{edu.name}</h4>
                      <h3 className="bold-text">{edu.school}</h3>
                      <p className="p-text">{edu.university}</p>
                    </motion.div>
                    <ReactTooltip
                      id={edu.name}
                      effect="solid"
                      arrowColor="var(--card-color)"
                      className="skills-tooltip"
                    >
                      {edu.school}
                    </ReactTooltip>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, 'app__skills'),
  'academics',
  'app__primarybg',
);
